module.exports = __webpack_public_path__ + "img/Retail17.b73c8092.png";